import moment from "moment";

const constructOptionSymbolsHelper = (tradeIdea) => {
  if (!tradeIdea || !Array.isArray(tradeIdea.legs) || tradeIdea.legs.length === 0) {
    throw new Error("Invalid tradeIdea or no legs available to construct option symbols");
  }

  const formatStrikePrice = (strikePrice) => {
    const centsSymbol = ~~(+(strikePrice) * 1000);
    const priceSymbol = `${centsSymbol}`.padStart(8, "0");
    return priceSymbol;
  };

  const symbolsArray = tradeIdea.legs.map((leg) => {
    const expirationDate = moment(leg.expiry_date).format("YYMMDD");
    const optionType = leg.put_call === "put" ? "P" : "C";
    const strikePrice = formatStrikePrice(leg.strike_price);

    return `${tradeIdea.symbol}${expirationDate}${optionType}${strikePrice}`;
  });
  return symbolsArray.join(",");
};

export const constructOptionSymbols = (tradeIdea) => {
  try {
    const symbols = constructOptionSymbolsHelper(tradeIdea);
    return symbols;
  }
  catch (error) {
    console.error("Error constructing option symbols:", error.message);
    return null;
  }
};

export const capitalizeFirstLetter = str =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getLegTypeText = (leg) => {
  const { buy_sell, put_call } = leg;

  if (buy_sell === "sell" && put_call === "call") {
    return "Short Call";
  }
  else if (buy_sell === "sell" && put_call === "put") {
    return "Short Put";
  }
  else if (buy_sell === "buy" && put_call === "call") {
    return "Long Call";
  }
  else if (buy_sell === "buy" && put_call === "put") {
    return "Long Put";
  }

  return "unknown";
};

export const formatDate = (dateString) => {
  return moment(dateString).format("MMM DD, YYYY");
};

export const formatCurrency = (amount) => {
  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const numberFormatter = (number, decimalPlaces = 2) => {
  if (isNaN(number)) return "";
  const formatter = customFormatter(decimalPlaces);

  let formattedNumber = formatter.format(number);
  if (decimalPlaces > 0) {
    formattedNumber = formattedNumber.replace(/\.0+$/, "");
    if (formattedNumber.endsWith(".")) {
      formattedNumber = formattedNumber.slice(0, -1);
    }
  }

  return formattedNumber;
};
const customFormatter = (decimalPlaces = 2) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};

export const formatDollarsCurrency = (amount) => {
  if (amount == null) return "N/A";
  return `$${parseFloat(amount).toFixed(2)}`;
};

export const isTradeIdeaExpired = (createdDate: string): boolean => {
  // Ensure the createdDate ends with "Z" to handle UTC times correctly
  const created = createdDate.endsWith("Z") ? new Date(createdDate) : new Date(createdDate + "Z");

  const now = new Date();

  // Calculate the difference in milliseconds
  const differenceInMs = now.getTime() - created.getTime();

  // Convert milliseconds to minutes
  const differenceInMinutes = differenceInMs / (1000 * 60);

  console.log("differenceInMinutes", differenceInMinutes);

  // Check if the difference exceeds 15 minutes
  return differenceInMinutes > 15;
};

export const getOrderType = (input) => {
  switch (input) {
    case "multileg":
    case "option":
      return "Market";
    case "otoco":
      return "Limit";
    default:
      return "";
  }
};

// dashboard helpers
export function formatDateToGMT(dateString) {
  const date = new Date(dateString);

  // Format the date to "04 September 2024"
  const formattedDate = date.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });

  // Convert to GMT time zone
  const timeInGMT = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "GMT" });

  return (
    <>
      {formattedDate}
      <br />
      {timeInGMT}
      {" "}
      GMT
    </>
  );
}

export const getAction = (side) => {
  if (side === "buy_to_open") {
    return "Buy";
  }
  else {
    return "Sell";
  }
};
